module.exports = __webpack_public_path__ + "img/Four.83f4577a.jpg";